export enum FaqLayouts {
  InPageText = 'in-page-text',
  Faq = 'faq',
}

export enum AccordionState {
  InitialOpen = 'initial_open',
  InitialClose = 'initial_close',
  AlwaysOpen = 'always_open',
}
